import { useEffect, useState } from 'react';
import { Box, Drawer, IconButton } from '@mui/material';
import Clusters from '../Clusters';
import CloseIcon from '@mui/icons-material/Close';
import { sxDrawer } from './styles';

const FligthsDrawer = ({
  duplicates,
  idDrawerSelected,
  infoFlightsSearch,
  flightsInUSD,
  setIsScroll,
  open,
  setOpen,
  handleCloseDrawer,
  businessTypes,
}) => {
  const [viewItems, setViewItems] = useState(5);
  const [flightsDta, setFlightsDta] = useState([]);

  useEffect(() => {
    if (idDrawerSelected) {
      const items = duplicates[idDrawerSelected] || [];

      let itemsToShow;

      if (items.length > 1) {
        itemsToShow = items.slice(1);
      } else {
        itemsToShow = items;
      }

      setFlightsDta(itemsToShow.slice(0, viewItems));
    }
  }, [idDrawerSelected, viewItems, duplicates]);

  const toggleDrawer = inOpen => event => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setViewItems(5);
    setOpen(inOpen);
  };

  return (
    <Drawer
      open={open}
      anchor="right"
      variant="temporary"
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: theme => sxDrawer(theme).drawerPaper,
      }}
    >
      <Box role="presentation" sx={theme => sxDrawer(theme).drawerBox}>
        <IconButton
          sx={theme => sxDrawer(theme).closeButton}
          onClick={handleCloseDrawer}
        >
          <CloseIcon />
        </IconButton>

        {flightsDta.length > 0 && (
          <Clusters
            flightsDta={flightsDta}
            viewItems={viewItems}
            viewOption={
              idDrawerSelected ? duplicates[idDrawerSelected].length : 0
            }
            handleSeeMore={() => setViewItems(viewItems + 5)}
            search_type={infoFlightsSearch?.trip_type}
            flightsInUSD={flightsInUSD}
            setIsScroll={setIsScroll}
            businessTypes={businessTypes}
            isDrawer
          />
        )}
      </Box>
    </Drawer>
  );
};

export default FligthsDrawer;
